//import { BreadContext } from "../../utils/context/breadcrum";
import Icon from "../../Icons/general/Icon";

function NoPermission() {
  //const { setRuta } = BreadContext();
  
  return (
   <div className="min-h-screen w-full flex items-center justify-center bg-white">
       <div className="w-[90%] max-w-[650px] bg-white border border-slate-300 rounded-[20px] shadow-lg shadow-default px-8 py-8 flex items-center">
          {/* LADO IZQUIERDO */}
          <div className="flex items-center justify-center pr-7">
             <div className="w-[120px] h-[120px] rounded-full bg-red-50 flex items-center justify-center">
               {/* Candado */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="w-[68px] h-[68px] text-red-700"
                >
                  <rect x="5" y="11" width="14" height="10" rx="2" />
                  <path d="M8 11V7a4 4 0 0 1 8 0v4" />
                  <circle
                    cx="12"
                    cy="16"
                    r="1.3"
                    fill="currentColor"
                    stroke="none"
                  />
                  <path d="M12 17.3V19" />
                </svg>
             </div>
          </div>
           {/* DIVISOR VERTICAL */}
          <div className="w-px h-[160px] bg-gray-200" />
           {/* LADO DERECHO */}
          <div className="flex-1 pl-8">
             <h2 className="text-red-700 text-[28px] font-bold leading-none mb-5">
                Acceso restringido
             </h2>
             <p className="text-gray-800 text-[16px] mb-6">
                Esta opción no está habilitada para su usuario.
             </p>
             {/* DIVISOR HORIZONTAL */}
             <div className="w-full h-px bg-gray-200 mb-5" />
             <div className="flex items-start gap-3">
                {/* Icono usuario */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.7"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="
                    w-7 h-7
                    text-gray-500
                    flex-shrink-0
                  "
                >
                  <circle cx="12" cy="7" r="4" />
                  <path d="M5.5 21v-2a6.5 6.5 0 0 1 13 0v2" />
                </svg>

                <p className="text-gray-700 text-[15px] leading-relaxed">
                  Si necesita acceder, comuníquese con
                  <br />
                  <span className="font-semibold text-gray-800">
                     el administrador de la aplicación.
                  </span>
                </p>
             </div>
          </div>
       </div>
   </div>
  ) 
}


export default NoPermission;
